import React, { FC } from 'react';
import { Dialog, DialogContent, DialogProps } from '@material-ui/core';
import { CalorieBanner } from 'menus/components/CalorieBanner';
import { useConfig } from 'common/providers/configProvider';
import { useCalories } from 'common/providers/caloriesProvider/CaloriesContext';
import { shouldDisplayCaloriesInfo } from 'menus/utils/caloriesHelpers';
import classNames from 'classnames';
import ArrowBackButton from '../ArrowBackButton';
import styles from './NewModal.styles';

interface NewModalProps extends DialogProps {
  dataTestId?: string;
  handleClose?: () => void;
  overlayStyling?: string;
  fullScreen?: boolean;
  fullWidth?: boolean;
  showHeader?: boolean;
  displayCaloriesBanner?: boolean;
  className?: string;
  showBackArrow?: boolean;
}

const NewModal: FC<NewModalProps> = ({
  children,
  dataTestId = 'availableSoon',
  open = false,
  handleClose = () => undefined,
  fullScreen,
  showHeader = true,
  fullWidth,
  className,
  showBackArrow = true,
  displayCaloriesBanner = true,
  ...props
}) => {
  const classes = styles();

  const { userCaloriesEnabled } = useCalories();

  const {
    content: {
      newDesignFlags: { brandCaloriesEnabled },
    },
  } = useConfig();

  const shouldShowCalorieBanner =
    shouldDisplayCaloriesInfo(brandCaloriesEnabled, userCaloriesEnabled) && displayCaloriesBanner;

  const headerStyles = classNames([classes.header], {
    [classes.increasedHeader]: !showBackArrow,
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      data-testid={`${dataTestId}-modal`}
      aria-labelledby="modal-title"
      aria-describedby="modal-content"
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      {...props}
    >
      {showHeader && (
        <>
          <div className={headerStyles}>
            <div className={classes.arrowBack}>
              {showBackArrow && <ArrowBackButton variant="filled" onClick={handleClose} />}
            </div>
          </div>
          {shouldShowCalorieBanner && <CalorieBanner />}
        </>
      )}
      <DialogContent id="modal-content" data-testid="modalContent" className={className}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default NewModal;
